import React, { FC, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import { getDateMonth, getDateFormat } from 'src/utils/dateSet';
import { myInfoDataStore } from 'src/store/myInfo';
import { salaryDataStore } from 'src/store/mySalaryInfo';
import { setDeDataStore } from 'src/fetch/data/store';
import { gridOption } from './gridOption';
import './style.scss';

interface Props {
  data?: any;
}

const CurrentWork: FC<Props> = ({ data }) => {
  const dataSet = {};
  const myInfoDataStateResult = myInfoDataStore((state: any) => state.result).data || {};
  const salaryInfoDataStateResult = salaryDataStore((state: any) => state.result).data || {};
  const orgData = salaryInfoDataStateResult || [];
  const workData = [salaryInfoDataStateResult];

  const totalCount = 1;
  const bindStateData = setDeDataStore(state => state.bindData);
  const optionSet: any = gridOption(workData, orgData, totalCount, bindStateData);
  const stateOption: any = {
    label: optionSet.label || [],
    data: optionSet.data || [],
    styleDef: optionSet.styleDef,
    rowStyleDef: {},
    totalCount,
  };

  const rowClickEvt = () => {};
  const pagingClick = () => {};
  const sortClickEvt = () => {};

  return (
    <div className="_step_b_current_work">
      <div className="_content">
        <TableGrid
          gridOption={stateOption}
          rowClickEvt={rowClickEvt}
          pagingClick={pagingClick}
          sortClickEvt={sortClickEvt}
          dataType="object"
          viewType="type1"
        />
      </div>
    </div>
  );
};

export default CurrentWork;
